/*!
 * SAPUI5
 * Copyright (c) 2025 SAP SE or an SAP affiliate company. All rights reserved.
 */
export const initialValueUnicode = "\u2013"; // Unicode Character 'EN DASH' (U+2013)
export const emptyValueUnicode = "⁣"; // Unicode Character 'INVISIBLE SEPARATOR' (U+2063)

export const QuickSelectDataSourceTypeTreeNode = "quickSelectDataSourceTreeNode";
